const ALL_API = {
  // 据member_no获取会员信息
  getMemberInfoByNo: {
    method: 'get',
    url: '/api/wechat/memberInfoByNo'
  },
  // 根据member_no生成会员唯一的动态码
  generateDynamicCode: {
    method: 'post',
    url: '/api/wechat/generateDynamicCode'
  },
  // 编辑会员信息
  memberUpdate: {
    method: 'put',
    url: '/api/wechat/memberUpdate'
  },
  // 更换手机号，发送手机验证码
  memberSendCode: {
    method: 'post',
    url: '/api/wechat/memberSendCode'
  },
  // 更换会员手机号码
  changeMemberMobile: {
    method: 'put',
    url: '/api/wechat/changeMemberMobile'
  },
  // 获取小程序appid
  getMiniAppId: {
    method: 'put',
    url: '/api/wechat/getMiniAppId'
  },
  // 获取wx签名
  getWechatSign: {
    url: `/api/wechat/getSignPackage`,
    method: 'post'
  }
}

export default ALL_API



// WEBPACK FOOTER //
// ./src/api/member/index.js